import { createAsyncThunk } from '@reduxjs/toolkit';
import { DocumentRequestFormConstants } from '../../constants';
import DocumentRequestService from '../../../../services/documentRequestService';

export const submitForm = createAsyncThunk(`${DocumentRequestFormConstants.StoreSliceName}/submitForm`, async (form, { rejectWithValue }) => {
    try {
        const {documentRequest, resetForm} = form
        const response = await DocumentRequestService.submitDocumentRequestForm(documentRequest);
        if(response?.status === 200) {
            resetForm()
        }
        return response
    } catch (error) {
        // TODO - Log the error;
        console.error('Error in submitForm Thunk', error);
        return rejectWithValue(error.message);
    }
});
